import {getRequest, postRequest} from "redux-request-middleware";
import {eGoldHostUrl} from "./egold-config";
import {IBankVerificationDetails} from "egold/pages/sellGold/bankDetails";

export enum Actions {
    REQUEST_BUY_PRICE = "REQUEST_BUY_PRICE",
    REQUEST_VERIFY_BUY_PRICE = "REQUEST_VERIFY_BUY_PRICE",
    REQUEST_SELL_PRICE = "REQUEST_SELL_PRICE",
    REQUEST_GET_BALANCE = "REQUEST_GET_BALANCE",
    REQUEST_DELIVERY_PRODUCTS = "REQUEST_DELIVERY_PRODUCTS",
    REQUEST_DELIVERY_PINCODE_CHECK = "REQUEST_DELIVERY_PINCODE_CHECK",
    REQUEST_INVOICE = "REQUEST_INVOICE",
    REQUEST_TRANSACTIONS = "REQUEST_TRANSACTIONS",
    REQUEST_REDEEM_GOLD = "REQUEST_REDEEM_GOLD",
    REQUEST_REGISTER_USER = "REQUEST_REGISTER_USER",
    REQUEST_ORDER_STATUS = "REQUEST_ORDER_STATUS",
    REQUEST_DELIVERY_STATUS = "REQUEST_DELIVERY_STATUS",
    REQUEST_USER_DETAILS = "REQUEST_USER_DETAILS",
    SELECTED_PRODUCT_INDEX = "SELECTED_PRODUCT_INDEX",
    HIDE_TOAST = "HIDE_TOAST",
    SHOW_TOAST = "SHOW_TOAST",
    SHOW_REGISTER_MODAL = "SHOW_REGISTER_MODAL",
    HIDE_REGISTER_MODAL = "HIDE_REGISTER_MODAL",
    CLEAR_VERIFY_PRICE = "CLEAR_VERIFY_PRICE",
    REQUEST_PAYMENT_LINK = "REQUEST_PAYMENT_LINK",
    CLEAR_PAYMENT_LINK = "CLEAR_PAYMENT_LINK",
    REQUEST_VERIFY_SELL_PRICE = "REQUEST_VERIFY_SELL_PRICE",
    REQUEST_VERIFY_BANK_ACCOUNT = "REQUEST_VERIFY_BANK_ACCOUNT",
    REQUEST_TRANSACTIONS_STATUS = "REQUEST_TRANSACTIONS_STATUS",
    CLEAR_BANK_DETAILS_SUCCESS_RESPONSE = "CLEAR_BANK_DETAILS_SUCCESS_RESPONSE",
    SET_KYC_STATUS = "SET_KYC_STATUS",
    UPDATE_VERIFIED_BANK_DETAILS = "UPDATE_VERIFIED_BANK_DETAILS",
    CLEAR_ELIGIBLE_SELL_AMOUNT = "CLEAR_ELIGIBLE_SELL_AMOUNT",
}

export function getBuyPrice() {
    return (dispatch) => {
        dispatch(
            getRequest(
                Actions.REQUEST_BUY_PRICE,
                "/buy-price",
                null,
                null,
                null,
                eGoldHostUrl,
            ),
        );
    };
}

export function verifyBuyPrice(vendor: string, goldInfo: any) {
    return (dispatch) => {
        dispatch(
            postRequest(
                Actions.REQUEST_VERIFY_BUY_PRICE,
                `/verify-price?vendor=${vendor}`,
                {gold_info: goldInfo},
                null,
                null,
                null,
                eGoldHostUrl,
            ),
        );
    };
}

export function getSellPrice() {
    return (dispatch) => {
        dispatch(
            getRequest(
                Actions.REQUEST_SELL_PRICE,
                "/sell-price",
                null,
                null,
                null,
                eGoldHostUrl,
            ),
        );
    };
}

export function getBalance(vendor: string, vendorId: number) {
    return (dispatch) => {
        dispatch(
            getRequest(
                Actions.REQUEST_GET_BALANCE,
                `/balance?vendor=${vendor}&vendor_id=${vendorId}`,
                null,
                null,
                null,
                eGoldHostUrl,
            ),
        );
    };
}

export function getDeliveryProducts(vendor: string) {
    return (dispatch) => {
        dispatch(
            getRequest(
                Actions.REQUEST_DELIVERY_PRODUCTS,
                `/delivery/products?vendor=${vendor}`,
                null,
                null,
                null,
                eGoldHostUrl,
            ),
        );
    };
}

export function deliveryPincodeCheck(vendor: string, pincode: number) {
    return (dispatch) => {
        dispatch(
            postRequest(
                Actions.REQUEST_DELIVERY_PINCODE_CHECK,
                `/delivery/validate-pincode?vendor=${vendor}`,
                {pin_code: pincode},
                null,
                null,
                null,
                eGoldHostUrl,
            ),
        );
    };
}

export function redeemGold(vendor: string, userId: number, userInfo: any) {
    return (dispatch) => {
        dispatch(
            postRequest(
                Actions.REQUEST_REDEEM_GOLD,
                `/delivery/redeem-gold?vendor=${vendor}`,
                {user_id: userId, user_info: userInfo},
                null,
                null,
                null,
                eGoldHostUrl,
            ),
        );
    };
}

export function getOrderStatus(vendor: string, orderType: string, txnId: number) {
    return (dispatch) => {
        dispatch(
            getRequest(
                Actions.REQUEST_ORDER_STATUS,
                `/order-status?vendor=${vendor}&order_type=${orderType}&txn_id=${txnId}`,
                null,
                null,
                null,
                eGoldHostUrl,
            ),
        );
    };
}

export function getTransactions(vendor: string, vendorId: string, page: number) {
    return (dispatch) => {
        dispatch(
            getRequest(
                Actions.REQUEST_TRANSACTIONS,
                `/transactions?vendor=${vendor}&vendor_id=${vendorId}&page=${page}`,
                null,
                null,
                null,
                eGoldHostUrl,
            ),
        );
    };
}

export function getInvoice(vendor: string, txnId: number) {
    return (dispatch) => {
        dispatch(
            getRequest(
                Actions.REQUEST_INVOICE,
                `/invoice?vendor=${vendor}&txn_id=${txnId}`,
                null,
                null,
                null,
                eGoldHostUrl,
            ),
        );
    };
}

export function registerUser(vendor: string, userInfo: any, userId: number) {
    return (dispatch) => {
        dispatch(
            postRequest(
                Actions.REQUEST_REGISTER_USER,
                `/users?vendor=${vendor}`,
                {user_id: userId, user_info: userInfo},
                null,
                null,
                null,
                eGoldHostUrl,
            ),
        );
    };
}

export function getDeliveryStatus(vendor: string, txnId: number) {
    return (dispatch) => {
        dispatch(
            getRequest(
                Actions.REQUEST_DELIVERY_STATUS,
                `/delivery/status?vendor=${vendor}&txn_id=${txnId}`,
                null,
                null,
                null,
                eGoldHostUrl,
            ),
        );
    };
}
export function getUser(userId: string) {
    return (dispatch) => {
        dispatch(
            getRequest(
                Actions.REQUEST_USER_DETAILS,
                `/user?user_id=${userId}`,
                null,
                null,
                null,
                eGoldHostUrl,
            ),
        );
    };
}
export function getPaymentLink(paymentDetails: object) {
    return (dispatch) => {
        dispatch(
            postRequest(
                Actions.REQUEST_PAYMENT_LINK,
                `/payment-link`,
                paymentDetails,
                null,
                null,
                null,
                eGoldHostUrl,
            ),
        );
    };
}
export function getTransactionStatus(vendor: string, txnId: string) {
    return (dispatch) => {
        dispatch(
            getRequest(
                Actions.REQUEST_TRANSACTIONS_STATUS,
                `/transactions/status?vendor=${vendor}&txn_id=${txnId}`,
                null,
                null,
                null,
                eGoldHostUrl,
            ),
        );
    };
}
export function verifySellPrice(vendor: string, sellInfo: any) {
    return (dispatch) => {
        dispatch(
            postRequest(
                Actions.REQUEST_VERIFY_SELL_PRICE,
                `/sell/verify-price?vendor=${vendor}`,
                sellInfo,
                null,
                null,
                null,
                eGoldHostUrl,
            ),
        );
    };
}

export function sellGold(vendor: string, bankDetails: any) {
    return (dispatch) => {
        dispatch(
            postRequest(
                Actions.REQUEST_VERIFY_BANK_ACCOUNT,
                `/sell/verify-bank-account?vendor=${vendor}`,
                bankDetails,
                null,
                null,
                null,
                eGoldHostUrl,
            ),
        );
    };
}
export function setSelectedProductIndex(productIndex: number) {
    return { type: Actions.SELECTED_PRODUCT_INDEX, body: {productIndex}};
}
export function updateVerifiedBankDetails(bankAccount: IBankVerificationDetails) {
    return { type: Actions.UPDATE_VERIFIED_BANK_DETAILS, body: bankAccount};
}
export function hideToast() {
    return { type: Actions.HIDE_TOAST};
}
export function showToast(bgColor, msg) {
    return { type: Actions.SHOW_TOAST, body: {bgColor, msg}};
}
export function showRegisterModal() {
    return { type: Actions.SHOW_REGISTER_MODAL};
}
export function hideRegisterModal() {
    return { type: Actions.HIDE_REGISTER_MODAL};
}
export function clearVerifyPrice() {
    return { type: Actions.CLEAR_VERIFY_PRICE};
}
export function clearPaymentLink() {
    return { type: Actions.CLEAR_PAYMENT_LINK};
}
export function clearBankDetailsValidResponse() {
    return { type: Actions.CLEAR_BANK_DETAILS_SUCCESS_RESPONSE};
}
export function setKycStatus(pan: string) {
    return { type: Actions.SET_KYC_STATUS, body: {pan}};
}
export function  clearEligibleSellAmount() {
    return {type: Actions.CLEAR_ELIGIBLE_SELL_AMOUNT};
}